<template>
  <div class="d-flex gap-15 align-items-center">
    <span class="font-weight-bold cursor-pointer" @click="redirectBack">{{ backRouteTranslation }}</span>
    <i class="fa fa-chevron-left text-gray-500" aria-hidden="true"></i>
    <span class="font-weight-bold text-gray-500">{{ currentRouteTranslation }}</span>
  </div>
</template>
<script>
export default {
  name: 'InlineNavigation',
  props: {
    routeBackName: {
      type: String,
      required: true
    },
    routeBackParams: {
      type: Object,
      default: () => {}
    },
    currentRouteTranslation: {
      type: String,
      required: true
    },
    backRouteTranslation: {
      type: String,
      required: true
    }
  },
  methods: {
    redirectBack() {
      this.$router.push({ name: this.routeBackName, params: this.routeBackParams })
    },
  },
}
</script>
<style lang="scss" scoped>
.gap-15 {
  gap: 15px;
}
</style>
